import React from 'react';
import cx from 'clsx';
import { Box, makeStyles, Paper, Typography } from '@material-ui/core';
import makePrintStyles from 'components/ReportsModule/components/KeyboardingReport/hooks/make-print-styles';
import { calcMinutes } from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import { KeyStudentEngagementAssessmentAcceleratorModuleAttemptActivity } from 'types/schema-generated-types';
import SubText from './SubText';

type Props = {
  activities: KeyStudentEngagementAssessmentAcceleratorModuleAttemptActivity[];
};

const AttemptsDetails = ({ activities }: Props) => {
  const classes = useStyles();
  const printClasses = usePrintStyles();

  return (
    <Box className={classes.print} padding="0 32px">
      {activities.map(x => (
        <Box className={classes.container}>
          <Paper className={cx(classes.paper, printClasses.paper)} variant="outlined">
            <Typography className={printClasses.title}>{x.activity?.title}</Typography>
            <Box display="flex">
              <Typography
                className={printClasses.title}
                style={{ display: 'flex', flexDirection: 'column', marginRight: 24 }}
              >
                <SubText className={printClasses.title} style={{ fontSize: 12, fontWeight: 500 }}>
                  Time
                </SubText>
                {calcMinutes(x?.secondsSpent!)}
              </Typography>
              <Typography className={printClasses.title}>
                <SubText
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: 12,
                    fontWeight: 500
                  }}
                  className={printClasses.title}
                >
                  No. of tries
                </SubText>
                {x?.attemptCount}
              </Typography>
            </Box>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flex: 1,
    margin: '10px 0px'
  },
  paper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: 76,
    padding: '8px 16px 8px 16px',
    backgroundColor: '#FCFCFC'
  },
  print: {
    '@media print': { overflow: 'initial !important' }
  }
}));

const usePrintStyles = makePrintStyles({
  title: { fontSize: '24px !important' },
  paper: { padding: '16px !important' }
});

export default AttemptsDetails;
